import { useOnce } from '@utils/gtm/hooks/useOnce';

export const SessionScopeGTM = (main?: string, sub?: string) => {
  useOnce(() => {
    let userType = 'guest';

    try {
      const usr = JSON.parse(localStorage.getItem('loyaltyUserInfo') ?? '');
      userType = usr?.customer?.id ? 'member' : 'guest';
    } catch (err) {
      // console.log('User info parse error:', err);
    }

    dataLayer.push({
      session: {
        userType,
        content_group: main ?? '',
        content_group2: sub ?? '',
      },
    });
  });

  return null;
};
